var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("榜单会场活动管理")]),
      _vm._v(" "),
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          { staticStyle: { "margin-left": "0" } },
          [
            _c("el-input", {
              attrs: { placeholder: "输入活动名称查询", clearable: "" },
              model: {
                value: _vm.queryData.name,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "name", $$v)
                },
                expression: "queryData.name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", placeholder: "选择活动状态" },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { label: "未开始", value: 0 } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "进行中", value: 1 } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "已下线", value: 2 } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", placeholder: "选择渠道类型" },
                model: {
                  value: _vm.queryData.unionCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "unionCode", $$v)
                  },
                  expression: "queryData.unionCode",
                },
              },
              [
                _c("el-option", { attrs: { label: "淘宝", value: "TB" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "京东", value: "JD" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "拼多多", value: "PDD" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "唯品会", value: "WPH" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "抖音", value: "DY" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            staticStyle: { width: "fit-content", height: "40px" },
          },
          [
            _c(
              "el-button",
              {
                staticStyle: { height: "40px" },
                attrs: { type: "primary" },
                on: { click: _vm.onInquire },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                staticStyle: { height: "40px" },
                attrs: { type: "info", plain: "" },
                on: { click: _vm.onInitialize },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新增+")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { border: "", data: _vm.tableData, "tooltip-effect": "dark" },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "排序",
              align: "center",
              width: "60",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "活动名称",
              align: "center",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "mainImage",
              label: "头图",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.mainImage
                      ? _c("el-image", {
                          staticStyle: {
                            width: "80px",
                            height: "50px",
                            "border-radius": "4px",
                          },
                          attrs: {
                            src: scope.row.mainImage,
                            "preview-src-list": [scope.row.mainImage],
                            fit: "cover",
                          },
                        })
                      : _c("div", { staticClass: "table-img-placeholder" }, [
                          _c("i", { staticClass: "el-icon-picture-outline" }),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "unionCode",
              label: "渠道类型",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.unionCodeMap[scope.row.unionCode] ||
                            scope.row.unionCode
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "startTime",
              label: "活动开始时间",
              align: "center",
              "min-width": "160",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "endTime",
              label: "活动结束时间",
              align: "center",
              "min-width": "160",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              align: "center",
              "min-width": "160",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "活动状态",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c("div", { staticStyle: { color: "#E6A23C" } }, [
                          _vm._v("未开始"),
                        ])
                      : scope.row.status === 1
                      ? _c("div", { staticStyle: { color: "#67c23A" } }, [
                          _vm._v("进行中"),
                        ])
                      : scope.row.status === 2
                      ? _c("div", { staticStyle: { color: "#909399" } }, [
                          _vm._v("已下线"),
                        ])
                      : _c("div", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              align: "center",
              width: "150",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20 page_box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page.page,
              "page-sizes": [20, 50, 100],
              "page-size": _vm.queryData.page.size,
              layout: "total, prev, pager, next, sizes, jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: _vm.isAdd ? "活动添加" : "活动编辑",
            width: "720px",
            top: "8vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动渠道", prop: "unionCode" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.ruleForm.unionCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "unionCode", $$v)
                        },
                        expression: "ruleForm.unionCode",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "淘宝", value: "TB" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "京东", value: "JD" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "拼多多", value: "PDD" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "唯品会", value: "WPH" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "抖音", value: "DY" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请输入",
                      maxlength: "50",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动排序", prop: "sortNo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入", type: "number" },
                    model: {
                      value: _vm.ruleForm.sortNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "sortNo", _vm._n($$v))
                      },
                      expression: "ruleForm.sortNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转类型", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onTypeChange },
                      model: {
                        value: _vm.ruleForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "type", $$v)
                        },
                        expression: "ruleForm.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("ID跳转"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("URL跳转"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " ", prop: "transUrl" } },
                [
                  _vm.ruleForm.type === 0
                    ? _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入ID" },
                        model: {
                          value: _vm.ruleForm.transUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "transUrl", $$v)
                          },
                          expression: "ruleForm.transUrl",
                        },
                      })
                    : _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入URL" },
                        model: {
                          value: _vm.ruleForm.transUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "transUrl", $$v)
                          },
                          expression: "ruleForm.transUrl",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "头图", prop: "mainImage" } },
                [
                  _c(
                    "upload",
                    {
                      attrs: {
                        name: "mainImage",
                        "img-url": _vm.ruleForm.mainImage,
                        width: "200px",
                        height: "100px",
                      },
                      on: {
                        pictureAddress: function ($event) {
                          return _vm.onPictureAddress($event)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "upload-tip" }, [
                        _vm._v("推荐尺寸：662*200px"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间", prop: "timeRange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetimerange",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    on: { change: _vm.onTimeChange },
                    model: {
                      value: _vm.ruleForm.timeRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "timeRange", $$v)
                      },
                      expression: "ruleForm.timeRange",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("请选择活动时间（未选择时间则默认为长期有效状态）"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _vm.isAdd
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }